
import { ArticleItem } from '@/components/article'
import { LifestyleItem } from '@/components/lifestyle'
import { ProductItem } from '@/components/product'
import i18n from '@/i18n'
import Vue from 'vue'

export default Vue.extend({
    components: { ProductItem, ArticleItem, LifestyleItem },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,
            muted: true,
            index: {},
            products: [],
            experience: [],
            lifestyle: [],
            scroll: 0,
            landscape: true,
        }
    },

    computed: {
        productTagsGroup(): any[] {
            const n = 5
            const { productTags } = this.$root.$data

            return Array.from(Array(Math.ceil(productTags.length / n))).map((_, i) =>
                productTags.slice(i * n, (i + 1) * n)
            )
        }
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },

    async mounted() {

        if (document.documentElement.clientWidth > 768) {
            window.addEventListener('scroll', this.onScroll)
        }

        // Index
        try {
            const response = await this.$axios.get('/index', {
                params: {
                    fields: '*,translations.*',
                    'deep[translations][_filter][languages_code][_eq]': i18n.locale
                }
            })
            this.index = response.data.data.map(item => item.translations)

            console.log(response)
        } catch (error) {
            console.error('Error fetching term data:', error)
        }

        // Products
        try {
            const response = await this.$axios.get('/product', {
                params: {
                    fields: '*,translations.*',
                    'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                    sort: 'date_created',
                    limit: 10
                }
            })
            this.products = response.data.data

            // console.log(this.products);
        } catch (error) {
            console.error('Error fetching term data:', error)
        }


        try {
            const response = await this.$axios.get('/article', {
                params: {
                    fields: '*,translations.*',
                    'filter[type][_eq]': 'experience',
                    'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                    sort: 'date_created',
                    limit: 4
                }
            })
            this.experience = response.data.data
        } catch (error) {
            console.error('Error fetching term data:', error)
        }

        // Lifestyle
        try {
            const response = await this.$axios.get('/article', {
                params: {
                    fields: '*,translations.*',
                    'filter[type][_eq]': 'lifestyle',
                    'deep[translations][_filter][languages_code][_eq]': i18n.locale,
                    sort: 'date_created',
                    limit: 3
                }
            })
            this.lifestyle = response.data.data
        } catch (error) {
            console.error('Error fetching term data:', error)
        }

    },

    methods: {
        onScroll() {
            const el = document.querySelector('.product-tag') as HTMLElement
            const wst = document.documentElement.scrollTop
            if (wst > el.offsetTop) {
                const scroll = (el.offsetTop - wst) * (document.documentElement.clientWidth / 1680) * 2
                this.scroll = scroll > -400 ? scroll : -400
            } else {
                this.scroll = 0
            }
        },

        getImageUrl() {
            const imageField = this.landscape ? 'landscape_cover' : 'cover'
            const imageUrl = this.experience[0].translations[0][imageField]
            return imageUrl ? `${this.$assets}/${imageUrl}` : ''
        }
    },

    metaInfo() {
        return {
            title: "BOBU AFRICA | Natural Travel | Products | Creativity",
            link: [
                { rel: "canonical", href: `${window.location.href}` }
            ],
            meta: [
                { name: 'description', content: "Bobu Africa ventures with you into Africa’s hidden gems, tailoring not only journeys, but unforgettable and fulfilling experiences for you" },
                { property: "og:type", content: "website" },
                { property: "og:url", content: `${window.location.href}` },
                { property: "og:title", content: "BOBU AFRICA | Natural Travel | Products | Creativity" },
                { property: "og:description", content: "Bobu Africa ventures with you into Africa’s hidden gems, tailoring not only journeys, but unforgettable and fulfilling experiences for you" },
                { property: "og:image", content: "https://static.bobuafrica.com/loading.webp" },

                { property: "twitter:card", content: "summary_large_image" },
                { property: "twitter:url", content: `${window.location.href}` },
                { property: "twitter:title", content: "BOBU AFRICA | Natural Travel | Products | Creativity" },
                { property: "twitter:description", content: "Bobu Africa ventures with you into Africa’s hidden gems, tailoring not only journeys, but unforgettable and fulfilling experiences for you" },
                { property: "twitter:image", content: "https://static.bobuafrica.com/loading.webp" }
            ]
        }
    }
})
